module.exports = __webpack_public_path__ + "media/images/noticias/viejas/place_pasaje-3603f24aa7b13ee8eb33dde490664baf.jpg";